import { CommonModule } from '@angular/common'
import { Component, DestroyRef, inject, input, ElementRef, ViewChild, AfterViewInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { debounceTime, fromEvent } from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { SearchRoutePaths } from 'src/app/core/data/search-route-paths.data'

@Component({
  selector: 'app-breadcrumbs',
  template: `
    <div class="breadcrumbs" #container>
      @if(asset(); as asset) {
        <div class="breadcrumbs__container">
          @if (toggleBreadcrumb) {
            <div class="breadcrumbs__toggle" data-testid="breadcrumbs">
              <div class="breadcrumbs__item">
                <a i18n="@@breadcrumbs.equipment-link.anchor-text" [routerLink]="[RoutePaths.Search]" class="breadcrumbs__link">Equipment</a>
              </div>
              <div class="breadcrumbs__divider">/</div>
              <div class="breadcrumbs__item">
                <a [routerLink]="[SearchRoutePaths.CategoryFull.replace(':category', asset.filter_category)]" class="breadcrumbs__link">{{ asset.category }}</a>
              </div>
              <div class="breadcrumbs__divider">/</div>
            </div>
          } @else {
            <div role="button" data-testid="toggle" aria-label="Display full breadcrumbs" class="breadcrumbs__item breadcrumbs__item--hover" (click)="toggleBreadcrumb = !toggleBreadcrumb">...</div>
            <div class="breadcrumbs__divider">/</div>
          }
          <div class="breadcrumbs__item">
            <a [routerLink]="[SearchRoutePaths.SubcategoryFull.replace(':category', asset.filter_category).replace(':subcategory', asset.filter_sub_category)]" class="breadcrumbs__link">{{ asset.sub_category }}</a>
          </div>
        </div>
      }
    </div>
  `,
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
  ],
})


export class BreadcrumbsComponent implements AfterViewInit {
  private _destroyRef = inject(DestroyRef)

  asset = input<IAsset>()

  @ViewChild('container') container!: ElementRef

  RoutePaths = RoutePaths
  SearchRoutePaths = SearchRoutePaths
  public toggleBreadcrumb = true

  ngAfterViewInit() {
    this.init()

    fromEvent(window, 'resize')
      .pipe(takeUntilDestroyed(this._destroyRef), debounceTime(200))
      .subscribe(() => {
        this.init()
      })
  }

  init(): void {
    if (this.isMobile()) {
      this.toggleBreadcrumb = false
    } else {
      this.toggleBreadcrumb = true
    }
  }

  isMobile(): boolean {
    return this.container.nativeElement.offsetWidth < 768
  }

}
